function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 25,
  cy: 30,
  r: 25,
  fill: "#E6E6E6"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 25,
  r: 25,
  fill: "#EDFFFA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28 2C40.6667 2 51 12.3333 51 25C51 37.6667 40.6667 48 28 48C15.3333 48 5 37.6667 5 25C5 12.3333 15.3333 2 28 2ZM28 0C14.2 0 3 11.2 3 25C3 38.8 14.2 50 28 50C41.8 50 53 38.8 53 25C53 11.2 41.8 0 28 0ZM38.5 19.4333H36.9333L32.1333 25L36.9 30.5667H38.4667V35.0333H28.3667V30.6333H29.9333L26.8 27H25.5V30.6333H27.2667V35.0667H17.5V30.5667H19.6333V25V19.4333H17.5V14.9333H19.9V16.6H21.2V14.9333H23.5667V16.6H24.8667V14.9333H27.2667V19.3667H25.5V23H26.8L29.9333 19.3667H28.3667V14.9333H38.5V19.4333Z",
  fill: "#48DBB4"
});

const SvgKeepGreenFormIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "keep-green-form-icon",
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKeepGreenFormIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/keep-green-form-icon.fa575cfe.svg";
export { ForwardRef as ReactComponent };